import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navigation from "./components/Navigation";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import NorthernLights from "./pages/NorthernLights";
import NorthernLightsTromso from "./pages/NorthernLightsTromso";
import SeasonalAdventures from "./pages/SeasonalAdventures";
import Philosophy from "./pages/Philosophy";
import Contact from "./pages/Contact";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Navigation />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/northern-lights" element={<NorthernLights />} />
          <Route path="/northern-lights-tromso" element={<NorthernLightsTromso />} />
          <Route path="/seasonal-adventures" element={<SeasonalAdventures />} />
          <Route path="/philosophy" element={<Philosophy />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
